"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATE_MSG = void 0;
exports.VALIDATE_MSG = {
    VIETNAMESE: {
        COMMON: {
            required: "Vui lòng nhập trường này",
        },
    },
};
